import {
  ROLE_CLIENT_ADMIN,
  ROLE_PLATFORM_HIXME_ADMIN,
} from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PageWrapper from 'enrollment-platform/PageWrapper'
import AncillaryReport from './AncillaryReport'
import { ANCILLARY_REPORT } from './paths'

const AncillaryReportRoute = {
  path: ANCILLARY_REPORT,
  component: PageWrapper,
  onEnter(
    _nextState: unknown,
    _replace: unknown,
    callback: (err?: unknown) => void
  ) {
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: AncillaryReport,
  },
}

export default AncillaryReportRoute
